import type { SpecialHour } from "../types";
import ConfirmRemove from "./ConfirmRemove";
import { DateField, TimeField } from "./fields";

type Props = {
  rows: SpecialHour[];
  busy: boolean;
  onChange: (rows: SpecialHour[]) => void;
  onSave: () => void;
};

function emptyRow(): SpecialHour {
  return { date: "", closed: true, open_time: "09:00", close_time: "18:00" };
}

export default function SpecialHours({ rows, busy, onChange, onSave }: Props) {
  function update(i: number, patch: Partial<SpecialHour>) {
    onChange(rows.map((row, idx) => (idx === i ? { ...row, ...patch } : row)));
  }

  return (
    <div>
      <div className="mb-5 flex items-center justify-between gap-3">
        <div>
          <h3 className="text-lg font-semibold">Jours exceptionnels</h3>
          <p className="mt-1 text-sm text-slate-500">Fériés, fermetures, horaires d’un jour.</p>
        </div>
        <button type="button" disabled={busy} onClick={onSave} className="pr-btn">
          {busy ? "Enregistrement…" : "Enregistrer"}
        </button>
      </div>
      <div className="space-y-3">
        {rows.map((row, i) => (
          <div key={i} className="grid grid-cols-1 items-center gap-3 rounded-2xl bg-mist px-4 py-3 sm:grid-cols-[1.2fr_auto_1fr_1fr_auto]">
            <DateField value={row.date} onChange={(date) => update(i, { date })} />
            <label className="flex items-center gap-2 text-sm">
              <input type="checkbox" checked={row.closed} onChange={(e) => update(i, { closed: e.target.checked })} />
              Fermé
            </label>
            {!row.closed ? (
              <>
                <TimeField value={row.open_time} onChange={(open_time) => update(i, { open_time })} />
                <TimeField value={row.close_time} onChange={(close_time) => update(i, { close_time })} />
              </>
            ) : (
              <>
                <span />
                <span />
              </>
            )}
            <ConfirmRemove question="Retirer ce jour ?" onConfirm={() => onChange(rows.filter((_, idx) => idx !== i))} />
          </div>
        ))}
      </div>
      <button type="button" className="mt-4 text-sm font-medium text-violet" onClick={() => onChange([...rows, emptyRow()])}>
        Ajouter un jour
      </button>
    </div>
  );
}
